export const canvasKeys = {
  all: [{ module: 'canvas' }] as const,
  courses: () => [{ ...canvasKeys.all[0], scope: 'courses' }] as const,
  courseStudents: () => [{ ...canvasKeys.all[0], scope: 'courseStudents' }] as const,
  courseStudentsByCourse: (courseId: string) => [{ ...canvasKeys.courseStudents()[0], courseId }] as const,
};
